import { Pipe, PipeTransform } from '@angular/core';
import { NavigationMenuItem } from '@shared/models';

@Pipe({
  name: 'mapNavigationMenuItem',
})
export class MapNavigationMenuItemPipe implements PipeTransform {
  transform(
    items: any[],
    idPropertyName: string,
    labelPropertyName: string,
    linkPropertyName: string,
    iconPropertyName?: string
  ): NavigationMenuItem[] {
    return items.map((x) => ({
      id: x[idPropertyName],
      label: x[labelPropertyName],
      link: x[linkPropertyName],
      icon: String.isNullOrWhiteSpace(iconPropertyName)
        ? null
        : x[iconPropertyName],
    }));
  }
}
